import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import TimelineHeader from "./timeline-header";
import TimelineItem from "./timeline-item";
import './timeline.scss';

const Timeline = () => {

    const [showAll, setShowAll] = useState(false);

    //const options = { threshold: 1, rootMargin: "-150px 0px -150px 0px", triggerOnce: true };
    //const [ref, inView] = useInView(options);

    const onShowMore = () => {
        setShowAll(!showAll);
    }

    const nextTimelineItems = [
        { title: "Gobal lists", description: "Find actors, crew, equipment etc from previous films" },
        { title: "Messages", description: "Send ad-hoc messages to actors and crew" },
        { title: "Comments", description: "Add comments to any item in Filmanize" },
        { title: "Episodic", description: "Add a series of scripts and plan shooting days across them all" },
    ];
    const futureTimelineItems = [
        { title: "Daily Budget", description: "See the budget for each shooting day" },
        { title: "Top Sheet", description: "View the top sheet for your budget" },
        { title: "Smart Days V2.0", description: "Use constraints and availability to generate optimized shooting schedule" },
        { title: "Vehicles", description: "Add vehicles to the breakdown" },
        { title: "Special Effects", description: "Add special effects to the breakdown" }
    ];

    return (
        <div className="marketing-timeline-container">
            <div className="marketing-titles">Planned Features</div>


            <div className="marketing-get-started">
                <div className="marketing-timeline-box">
                    <div className="marketing-timeline-content">
                        <p>This is not a fixed list, but is based on current user feedback. Once you have an account, you will be able to add and vote on feature requests to influence the order these additional functionalities are developed.</p>
                    </div>
                </div>
            </div>

            <div className={`timeline is-centered marketing-timeline ${showAll ? "marketing-timeline-all" : "marketing-timeline-half"}`}>
                <TimelineHeader title="2025" />
                {nextTimelineItems.map((item, index) => (
                    <TimelineItem
                        key={index}
                        title={item.title}
                        description={item.description}
                        last={index === nextTimelineItems.length - 1} />
                ))}
                <TimelineHeader title="Future" />
                {futureTimelineItems.map((item, index) => (
                    <TimelineItem
                        key={index}
                        title={item.title}
                        description={item.description}
                        last={index === nextTimelineItems.length - 1} />
                ))}
            </div>
            <div className="marketing-timeline-button-conatiner is-centerd">

                <button className="button timeline-button hollow-button" onClick={onShowMore}>Show {showAll ? "less" : "more"}</button>
            </div>
        </div>
    )
}

export default Timeline;